import { render } from "./taxCheckSj.vue?vue&type=template&id=70d76fdf&scoped=true"
import script from "./taxCheckSj.vue?vue&type=script&lang=js"
export * from "./taxCheckSj.vue?vue&type=script&lang=js"

import "./taxCheckSj.vue?vue&type=style&index=0&id=70d76fdf&lang=less&scoped=true"
import "./taxCheckSj.vue?vue&type=style&index=1&id=70d76fdf&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d76fdf"]])

export default __exports__